var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCreateAble)?_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-1"}),_c('select-hospital',{attrs:{"hospitals":_vm.hospitals}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }